import type { MonitoringSlices } from '.';
import type { StateCreator } from 'zustand';

import type { UUID, VehicleGroup } from '@cobliteam/common-types';

import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';

import SectionType from '../../types/SectionType';
import SortType from '../../types/SortType';

interface DevicesListFilters {
  sectionTypeFilter: SectionType;
  vehiclesFilter: UUID[];
  vehicleGroupsFilter: VehicleGroup[];
  searchBoxFilter: string;
  sortFilter: SortType;
}

interface DevicesListSlice {
  devicesListFilters: DevicesListFilters;
  showUnpluggedDialog: boolean;
  showObservationDialog: boolean;
  showDisassociateDeviceDialog: boolean;
  deviceToReportProblem?: DeviceFragment;
  deviceToDisassociate?: DeviceFragment;
  setDevicesListFilters: (filters: Partial<DevicesListFilters>) => void;
  clearDevicesListFilters: () => void;
  setDeviceToReportProblem: (props?: DeviceFragment) => void;
  setShowUnpluggedDialog: (show: boolean) => void;
  setShowObservationDialog: (show: boolean) => void;
  setDisassociateDeviceDialog: (show: boolean) => void;
  setDeviceToDisassociate: (device?: DeviceFragment) => void;
}

type StateCreatorDevicesList = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], DevicesListSlice>;

const createDevicesListSlice: StateCreatorDevicesList = (set) => ({
  devicesListFilters: {
    sectionTypeFilter: SectionType.PLUGGED,
    vehiclesFilter: [],
    vehicleGroupsFilter: [],
    searchBoxFilter: '',
    sortFilter: SortType.ON,
  },
  showUnpluggedDialog: false,
  showObservationDialog: false,
  showDisassociateDeviceDialog: false,
  setDevicesListFilters: (filters: Partial<DevicesListFilters>) =>
    set((state) => ({
      devicesListFilters: { ...state.devicesListFilters, ...filters },
    })),
  deviceToDisassociate: undefined,
  clearDevicesListFilters: () =>
    set(() => ({
      devicesListFilters: {
        sectionTypeFilter: SectionType.PLUGGED,
        vehiclesFilter: [],
        vehicleGroupsFilter: [],
        searchBoxFilter: '',
        sortFilter: SortType.ON,
      },
    })),
  setShowUnpluggedDialog: (showUnpluggedDialog: boolean) => set({ showUnpluggedDialog }),
  setDeviceToReportProblem: (device?: DeviceFragment) => set({ deviceToReportProblem: device }),
  setShowObservationDialog: (showObservationDialog: boolean) => set({ showObservationDialog }),
  setDisassociateDeviceDialog: (showDisassociateDeviceDialog: boolean) => set({ showDisassociateDeviceDialog }),
  setDeviceToDisassociate: (device?: DeviceFragment) => set({ deviceToDisassociate: device }),
});

export type { DevicesListSlice, DevicesListFilters };
export default createDevicesListSlice;
